import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import { ProductCategory } from '../../models/product-category';
import { map } from 'rxjs/operators';

@Injectable()
export class ProductCategoryService {
  constructor(private http: ApiClient) {}

  public getProductCategories(excludeDeleted = 1) {
    return this.http.get<ProductCategory[]>(
      `productCategories?excludeDeleted=${excludeDeleted}`
    );
  }

  public getProductCategory(
    id: number,
    includes: string[],
    appends: string[] = [],
    select: Array<keyof ProductCategory> = []
  ) {
    const qs = [
      this.http.getWiths(includes) +
        '&' +
        this.http.urlSerializeArray(appends, 'attributes'),
      this.http.urlSerializeArray(select, 'select')
    ].join('&');
    return this.http.get<ProductCategory | Partial<ProductCategory>>(
      `productCategories/${id}${qs}`
    );
  }

  public getProductCategoriesById(
    ids: number[],
    includes: string[],
    appends: string[] = [],
    select: Array<keyof ProductCategory> = []
  ) {
    if (ids.length === 1) {
      return this.getProductCategory(ids[0], includes, appends, select).pipe(
        map((category) => [category])
      );
    }
    const qs = [
      this.http.getWiths(includes) +
        '&' +
        this.http.urlSerializeArray(appends, 'attributes'),
      this.http.urlSerializeArray(select, 'select')
    ].join('&');

    return this.http.get<ProductCategory[] | Partial<ProductCategory>[]>(
      `productCategories/${ids.join(',')}${qs}`
    );
  }

  public addProductCategory(productCategory: Partial<ProductCategory>) {
    return this.http.post<ProductCategory>(
      `productCategories`,
      productCategory
    );
  }

  public updateProductCategory(
    id: number,
    productCategory: Partial<ProductCategory>
  ) {
    return this.http.put(`productCategories/` + id, productCategory);
  }

  uploadImage(image: File, categoryId: number) {
    const formData = new FormData();
    formData.append('image', image);
    return this.http.post(`productCategories/${categoryId}/image`, formData);
  }

  deleteImage(categoryId: number) {
    return this.http.delete(`productCategories/${categoryId}/image`);
  }

  getSubcategories(categoryId: number) {
    return this.http.get<ProductCategory[]>(
      `productCategories/${categoryId}/subcategories`
    );
  }

  getItems(id: number, includeSubcategories: boolean) {
    return this.http.get<any[]>(
      `productCategories/${id}/items?includeSubcategories=${
        includeSubcategories ? 1 : 0
      }`
    );
  }

  getCategoryGrid(type: 'hire' | 'retail' = 'hire') {
    return this.http.get<any[]>(`productCategories/forGrid?type=${type}`);
  }

  setOrder(category_ids: number[]) {
    return this.http.post<void>(`productCategories/set-order`, {
      category_ids
    });
  }
}
